import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Label
} from "reactstrap";
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import { frequencyOptions } from "Enums/fixedData"
import Select from "react-select"
import PriceInput from "components/PriceInput"
import CurrencyInput from 'react-currency-input-field';


const PaymentPlan = (props) => {
    const { data, id, updateFormData } = props

    const [formData, setFormData] = useState({
        total_price: "",
        payment_method: "",

        remaining_price: "",
        paid_price: "",
        original_price: "",
        until_month: "",
        until_year: "",
        recurring_payments: [],
        years: "",
        down_payment: "",
        payment_amount: "",
        payment_frequency: null,

        in_owner_installment: false,
        off_payments: []

    });

    const handleFieldChange = (e) => {
        setFormData((formData) => ({ ...formData, [e.target.name]: e.target.value }));
    }

    useEffect(() => {
        if (id) {
            if (data.payment_plan?.payment_method === "Cash") {
                setFormData({
                    ...formData,
                    payment_method: "Cash",
                    depost: data.payment_plan.depost,
                    in_owner_installment: false,
                    total_price: data.payment_plan.total_price
                })
            } else if (data.payment_plan?.payment_method === "Installment") {
                setFormData({
                    ...formData,
                    payment_method: "Installment",
                    in_owner_installment: false,
                    depost: data.payment_plan.depost,
                    years: data.payment_plan.years[0].years,
                    down_payment: data.payment_plan.years[0].down_payment,
                    payment_frequency: {
                        label: data.payment_plan.years[0].recurring_payments[0].payment_frequency,
                        value: data.payment_plan.years[0].recurring_payments[0].payment_frequency
                    },
                    payment_amount: data.payment_plan.years[0].recurring_payments[0].payment_amount,
                    total_price: data.payment_plan?.total_price,

                })
            } else {
                const loaadedData = data ?.payment_plan ?.owner_installment
                setFormData({
                    ...formData,
                    payment_method: "Owner Installment",
                    in_owner_installment: true,
                    depost: data.payment_plan.depost,
                    total_price: data.payment_plan?.total_price,
                    remaining_price: loaadedData ?.remaining_price,
                    paid_price: loaadedData ?.paid_price,
                    original_price: loaadedData ?.original_price ? loaadedData ?.original_price : "",
                    until_month: loaadedData ?.until_month,
                    until_year: loaadedData ?.until_year,
                    off_payments: loaadedData ?.off_payments,
                    recurring_payments: loaadedData ?.recurring_payments 
                })

            }
        }
        else {
            setFormData({ ...formData, ...data })
        }
    }, [id])

    const handleValidSubmit = async () => {
        props.finishHandler()
    }

    const getRemaining = () => {
        if (formData.total_price > 0 && formData.paid_price > 0) {
            return `${toCurrency(formData.total_price - formData.paid_price)} EGP`
        } else {
            return ""
        }
    }
    useEffect(() => {
        if (formData.total_price > 0 && formData.paid_price > 0) {
            setFormData({ ...formData, remaining_price: formData.total_price - formData.paid_price })
        }
    }, [formData.total_price, formData.paid_price]);
    
    return (
        <AvForm onValidSubmit={(e, v) => { handleValidSubmit(e, v) }}>
            <Container>
                <Card>
                    <CardBody>
                        <Row>
                            <Col className="mt-4 ">
                                <AvRadioGroup disabled={true} className="mt-2" inline name="payment_method" required value={formData?.payment_method} onChange={handleFieldChange} >
                                    <AvRadio label="Cash" value="Cash" />
                                    <AvRadio label="Installment" value="Installment" />
                                    <AvRadio label="Installment With Owner" value="Owner Installment" />
                                </AvRadioGroup>
                            </Col>

                        </Row>
                        <Row className='mt-3'>
                            <Col md={6} className="price-input"  >
                                <Label>Depost</Label>
                                <CurrencyInput
                                    disabled={true}
                                    id="depost"
                                    className="mb-3"
                                    name={"depost"}
                                    value={formData?.depost}
                                    allowNegativeValue={false}
                                    onValueChange={()=>{}}
                                />
                            </Col>
                            <Col md={6} className="price-input"  >
                                <Label>Total Price</Label>
                                <CurrencyInput
                                    disabled={true}
                                    id="price"
                                    className="mb-3"
                                    name={"total_price"}
                                    placeholder={"Price"}
                                    value={formData?.total_price}
                                    allowNegativeValue={false}
                                    decimalsLimit={2}
                                    onValueChange={() => {}}
                                />
                            </Col>
                        </Row>
                        {formData ?.payment_method === "Owner Installment" &&
                            <>
                                <Row>
                                    <Col md={6} className="price-input"  >
                                        <Label>Origin Price (Optional)</Label>
                                        <CurrencyInput
                                            disabled={true}
                                            id="price"
                                            className="mb-3"
                                            name={"original_price"}
                                            placeholder={"Price"}
                                            value={formData.original_price}
                                            allowNegativeValue={false}
                                            decimalsLimit={2}
                                            onValueChange={(value, name) => {
                                                setFormData({ ...formData, original_price: value })
                                            }}
                                        />
                                    </Col>
                                    <Col md={6} className="price-input"  >
                                        <Label>Down Payment*</Label>
                                        <CurrencyInput
                                            disabled={true}
                                            id="price"
                                            className="mb-3"
                                            name={"paid_price"}
                                            placeholder={"Price"}
                                            value={formData.paid_price}
                                            allowNegativeValue={false}
                                            decimalsLimit={2}
                                            onValueChange={(value, name) => {
                                                setFormData({ ...formData, paid_price: value })
                                            }}
                                        />
                                        {/* <Col md={6}  >
                                            <AvField
                                                className="mb-3"
                                                name={"paid_price"}
                                                label={"Paid Price"}
                                                bsSize="lg"
                                                required
                                                value={formData.paid_price}
                                                onChange={e => handleFieldChange(e)}
                                                placeholder={'paid price'}
                                                type="number"
                                                min={"1"}
                                            /> */}
                                    </Col>
                                    <Col md={6}>
                                        <AvField
                                            readOnly
                                            className="mb-3"
                                            name={"Remaining Price"}
                                            label={"Remaining Price"}
                                            bsSize="lg"
                                            value={getRemaining()}
                                            onChange={e => handleFieldChange(e)}
                                            placeholder={'Remaining Price'}
                                            type="text"
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={3}  >
                                        <AvField
                                            readOnly
                                            className="mb-3"
                                            name={"until_month"}
                                            label={"Until Month*"}
                                            bsSize="lg"
                                            required
                                            value={formData.until_month}
                                            onChange={e => handleFieldChange(e)}
                                            placeholder={'month'}
                                            step="1"
                                            pattern="\d+"
                                            type="number"
                                            min={"1"}
                                            max={"12"}
                                        />
                                    </Col>
                                    <Col md={3}  >
                                        <AvField
                                            readOnly
                                            className="mb-3"
                                            name={"until_year"}
                                            label={"Until Year*"}
                                            bsSize="lg"
                                            required
                                            value={formData.until_year}
                                            onChange={e => handleFieldChange(e)}
                                            placeholder={'year'}
                                            type="number"
                                            step="1"
                                            pattern="\d+"
                                            min={new Date().getFullYear()}
                                            max={new Date().getFullYear() + 30}


                                        />
                                    </Col>
                                </Row>
                                {formData ?.recurring_payments ?.map((recurringPayment, recurringIndex) => {
                                    return (
                                        <Row className="my-3 mx-2 py-2 bg-light" key={recurringIndex}>
                                            <Row className="pt-2 ">
                                                <Col md={6}>
                                                    <h5>Recurring Payment</h5>
                                                </Col>

                                                <Col md={6} className="d-flex justify-content-end my-2">

                                                </Col>
                                            </Row>
                                            <Col md={6} className="price-input"  >
                                                <Label>Payment Amount*</Label>
                                                <CurrencyInput
                                                    disabled={true}
                                                    id={`payment_amount${recurringIndex}`}
                                                    className="mb-3"
                                                    name={`payment_amount${recurringIndex}`}
                                                    placeholder={"Payment Amount"}
                                                    value={recurringPayment.payment_amount}
                                                    allowNegativeValue={false}
                                                    decimalsLimit={2}
                                                    required
                                                    onValueChange={(value, name) => {
                                                        const updatedList = formData.recurring_payments.map((recurringItem, itemIndex) => {
                                                            if (recurringIndex === itemIndex) {
                                                                return {
                                                                    ...recurringItem,
                                                                    payment_amount: value
                                                                }
                                                            } else {
                                                                return recurringItem
                                                            }
                                                        })
                                                        setFormData({ ...formData, recurring_payments: [...updatedList] })
                                                    }}
                                                />

                                            </Col>
                                            <Col md={6}>
                                                <label>Payment Frequency*</label>
                                                <Select
                                                    isDisabled={true}
                                                    placeholder={"Select"}
                                                    value={recurringPayment.payment_frequency ? {
                                                        label: recurringPayment.payment_frequency,
                                                        value: recurringPayment.payment_frequency
                                                    } : null}
                                                    options={frequencyOptions.filter(({ label: l1 }) => !formData.recurring_payments.some(({ payment_frequency: l2 }) => l2 === l1))}
                                                    className='mb-3 '
                                                    onChange={data => {
                                                        const updatedList = formData.recurring_payments.map((recurringItem, itemIndex) => {
                                                            if (recurringIndex === itemIndex) {
                                                                return {
                                                                    ...recurringItem,
                                                                    payment_frequency: data.value
                                                                }
                                                            } else {
                                                                return recurringItem
                                                            }
                                                        })
                                                        setFormData({ ...formData, recurring_payments: [...updatedList] })

                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    )
                                })
                                }
                                {formData ?.recurring_payments ?.length < 2 && <Col className="d-flex justify-content-end my-2 mx-2">

                                </Col>}
                                {formData ?.off_payments ?.map((offItem, offParentIndex) => {
                                    return (
                                        <Row className="my-3 mx-2 py-2 bg-light" key={offParentIndex}>
                                            <Col md={6} className="my-2"><h5> 
                                                {offParentIndex+1}{offParentIndex+1 === 1 && 'st'}{offParentIndex+1 === 2 && 'nd'}{offParentIndex+1 === 3 && 'rd'}{offParentIndex+1 >3 && 'th'} Payment Plan Type
                                                </h5></Col>
                                            <Col md={6} className="d-flex justify-content-end my-2">
                                            </Col>
                                            <Col md={6} >
                                                <AvField
                                                    readOnly
                                                    className="mb-3"
                                                    name={`payment_name${offParentIndex}`}
                                                    label={`Payment Name*`}
                                                    bsSize="lg"
                                                    value={offItem.payment_name}
                                                    onChange={e => {
                                                        const value = e.target.value
                                                        const updatedOffPayments = formData.off_payments.map((offItem, offIndex) => {
                                                            if (offParentIndex === offIndex) {
                                                                return {
                                                                    ...offItem,
                                                                    payment_name: value
                                                                }
                                                            }
                                                            return offItem
                                                        })
                                                        setFormData({ ...formData, off_payments: [...updatedOffPayments] })

                                                    }}
                                                    required
                                                    placeholder={"Payment Name"}
                                                />
                                            </Col>

                                            <Col md={6} className="price-input" >
                                                <Label>Payment Fees</Label>
                                                <CurrencyInput
                                                    disabled={true}
                                                    id={`Payment fees`}
                                                    className="mb-3"
                                                    name={`Payment feest`}
                                                    placeholder={"Payment Fees"}
                                                    value={offItem.payment_fees}
                                                    allowNegativeValue={false}
                                                    onValueChange={(value, name) => {}}
                                                />
                                            </Col>
                                            <Col md={6} >
                                                <AvField
                                                    readOnly
                                                    className="mb-3"
                                                    label={`year number`}
                                                    name={`year_number${offParentIndex}`}
                                                    bsSize="lg"
                                                    value={offItem.year_number}
                                                    onChange={e => {}}
                                                    type="number"
                                                    placeholder={"year number"}
                                                    />
                                            </Col>
                                            <Col md={6} >
                                                <AvField
                                                    readOnly
                                                    className="mb-3"
                                                    name={`month_number${offParentIndex}`}
                                                    label={"month number"}
                                                    bsSize="lg"
                                                    value={offItem.month_number}
                                                    onChange={e => {}}
                                                    type="number"
                                                />
                                            </Col>
                                        </Row>
                                    )
                                })
                            }
                                
                            </>
                        }
                        {formData ?.payment_method === "Installment" &&
                            <Row>
                                <Col md={6} >
                                    <AvField
                                        readOnly
                                        className="mb-3"
                                        name={`years`}
                                        label={`Years Of Installment`}
                                        bsSize="lg"
                                        value={formData.years}
                                        onChange={e => {}}
                                        required
                                        placeholder={"Years 1-30"}
                                        min="1"
                                        type="number"
                                        max="30"
                                    />
                                </Col>
                                <Col md={6} className="price-input" >
                                    <Label>Down Payment</Label>
                                    <CurrencyInput
                                        disabled={true}
                                        id={`down_payment`}
                                        className="mb-3"
                                        name={`down_payment`}
                                        placeholder={"Down Payment"}
                                        value={formData.down_payment}
                                        allowNegativeValue={false}
                                        decimalsLimit={2}
                                        required
                                        onValueChange={(value, name) => {

                                            setFormData({ ...formData, down_payment: value })
                                        }}
                                    />
                                </Col>
                                <Col md={6} className="price-input" >
                                    <Label>Payment Amount</Label>
                                    <CurrencyInput
                                        disabled={true}
                                        id={`payment_amount`}
                                        className="mb-3"
                                        name={`Payment Amount`}
                                        placeholder={"Payment Amount"}
                                        value={formData.payment_amount}
                                        allowNegativeValue={false}
                                        decimalsLimit={2}
                                    />
                                </Col>
                                <Col md={6}>
                                    <label>payment frequency</label>
                                    <Select
                                        isDisabled={true}
                                        placeholder={"Select"}
                                        value={formData.payment_frequency}
                                        options={frequencyOptions}
                                        className='mb-3 '
                                        onChange={data => {
                                            setFormData({ ...formData, payment_frequency: data })
                                        }}
                                    />
                                </Col>
                            </Row>
                        }
                    </CardBody>
                </Card>
                {props.children}
            </Container>
        </AvForm >
    )
}
const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(number);
}
export default PaymentPlan